<template>
  <div>
    <p
      v-if="text"
      class="jm-text-center"
      v-html="text"
      data-test="cta-text"
    ></p>
    <a :href="url" class="jm-text-decoration-none" target="_blank"
      ><base-button>{{ label }}</base-button></a
    >
  </div>
</template>

<script>
import BaseButton from '@/components/molecules/BaseButton.vue'

export default {
  name: 'BaseCTA',
  components: {
    BaseButton
  },
  props: {
    text: {
      type: String
    },
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>
